module.exports = __webpack_public_path__ + "static/1D1L-PR-1-30b593854c44f7c781dede06b4a89819.pdf";